/**
 * What was thrown, as a line fit for a log field.
 *
 * Its own module rather than a helper on the controller: `stripeAuthorize`
 * needs it too, and importing it from `StripeSessionAuthController` pulled that
 * component's whole React Native import graph into anything that touched it —
 * which stopped `stripeAuthorize.test.tsx` parsing at all.
 *
 * `String(error)` alone gives "[object Object]" for the plain `{ code, message }`
 * Stripe's SDK rejects with, so the one field we logged was the one that never
 * said why.
 */
export function describeThrown(error: unknown): string {
  if (error instanceof Error) return error.message
  try {
    return JSON.stringify(error) ?? String(error)
  } catch {
    return String(error)
  }
}
